import { render, staticRenderFns } from "./FulfillOrders.vue?vue&type=template&id=4b10f80e&scoped=true"
import script from "./FulfillOrders.vue?vue&type=script&lang=js"
export * from "./FulfillOrders.vue?vue&type=script&lang=js"
import style0 from "./FulfillOrders.vue?vue&type=style&index=0&id=4b10f80e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b10f80e",
  null
  
)

export default component.exports